import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Seo from "../components/Seo";
import { scrollToId } from "../lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => scrollToId(id), 300);
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Seo
        title="DIDIT | Home Interiors & Modular Interiors in Delhi NCR"
        description="DIDIT offers modular kitchens, wardrobes and end-to-end home interiors in Delhi NCR with quality, transparent costing, timely delivery and 10-year warranty on modulars."
        canonical="https://didithomes.com/"
      />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <About />
    </main>
  );
}
